import React from "react";
import { ObrasProvider } from "./context/obras-context";
import { Obras } from "./obras";
import { BaseInternalFormFactory } from "../../base-internal-form/base-internal-form-factory";

const ObrasFactory = () => {
    return (
        <BaseInternalFormFactory pageTitle={"Obras"}>
            <ObrasProvider>
                <Obras />
            </ObrasProvider>
        </BaseInternalFormFactory>
    );
};

export default ObrasFactory;
